import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

/* Shared header for the landing page and any sub-route (e.g. /help) so the
   nav never drifts out of sync between pages. Non-route links either scroll
   within the current page (onScrollLinkClick, landing page) or, when that's
   not provided, navigate to the corresponding section on the home page via
   a hash link (sub-routes). */
export default function SiteNav({
  navLinks,
  activeId,
  forceSolid = false,
  onScrollLinkClick,
  onContactClick,
  contactHref,
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  const renderLink = (link, className) => {
    if (link.route) {
      return (
        <Link key={link.id} to={link.route} className={`${className} ${activeId === link.id ? className + '--active' : ''}`} onClick={closeMobileMenu}>
          {link.label}
        </Link>
      );
    }
    if (!onScrollLinkClick) {
      return (
        <Link key={link.id} to={`/#${link.id}`} className={className} onClick={closeMobileMenu}>
          {link.label}
        </Link>
      );
    }
    return (
      <button
        key={link.id}
        onClick={() => { onScrollLinkClick(link.id); closeMobileMenu(); }}
        className={`${className} ${activeId === link.id ? className + '--active' : ''}`}
      >
        {link.label}
      </button>
    );
  };

  const contactCta = contactHref ? (
    <a href={contactHref} className="bp-btn-nav-cta" data-testid="nav-contact-cta">
      <span className="bp-nav-cta-label">Contact Us</span>
      <span className="bp-nav-cta-arrow" aria-hidden="true">↗</span>
    </a>
  ) : (
    <button onClick={onContactClick} className="bp-btn-nav-cta" data-testid="nav-contact-cta">
      <span className="bp-nav-cta-label">Contact Us</span>
      <span className="bp-nav-cta-arrow" aria-hidden="true">↗</span>
    </button>
  );

  return (
    <nav className={`bp-nav ${forceSolid ? 'bp-nav--scrolled' : ''}`} data-testid="nav">
      <div className="bp-nav-inner">
        <Link to="/" className="bp-nav-logo">
          <img src="/bulandipe-txtonly-v1. 1.png" alt="BulandiPe" className="bp-logo-img" />
        </Link>

        <div className="bp-nav-links">
          {navLinks.map(link => renderLink(link, 'bp-nav-link'))}
        </div>

        <div className="bp-nav-actions">
          {contactCta}
          <button
            className="bp-mobile-toggle"
            onClick={() => setMobileMenuOpen(open => !open)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={20} aria-hidden="true" /> : <Menu size={20} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="bp-mobile-menu" data-testid="mobile-menu">
          {navLinks.map(link => renderLink(link, 'bp-mobile-link'))}
          {contactHref ? (
            <a href={contactHref} className="bp-btn-nav-cta bp-mobile-cta">
              <span className="bp-nav-cta-label">Contact Us</span>
              <span className="bp-nav-cta-arrow" aria-hidden="true">↗</span>
            </a>
          ) : (
            <button onClick={() => { onContactClick?.(); closeMobileMenu(); }} className="bp-btn-nav-cta bp-mobile-cta">
              <span className="bp-nav-cta-label">Contact Us</span>
              <span className="bp-nav-cta-arrow" aria-hidden="true">↗</span>
            </button>
          )}
        </div>
      )}
    </nav>
  );
}
